// extracted by mini-css-extract-plugin
module.exports = {"terms":"SignUpTerms_terms__THsP3","link":"SignUpTerms_link__EeyrW"};